import { createFileRoute, Outlet } from '@tanstack/react-router';
import { TenantsPage } from '@/pages/tenants';
import { adminTenantsSearchSchema } from '@/routes/-shared/tenantsSearchSchema';

/**
 * La lista resta montata e il dettaglio dell'azienda si apre sopra di lei
 * sull'`Outlet`, come nella webapp: chiudere il pannello torna alla lista
 * con filtri e scorrimento di prima.
 */
export const Route = createFileRoute('/admin/_layout/tenants/_layout')({
  component: TenantsLayout,
  validateSearch: adminTenantsSearchSchema,
});

function TenantsLayout() {
  return (
    <>
      <TenantsPage />
      <Outlet />
    </>
  );
}
